module.exports = __webpack_public_path__ + "static/img/image.ae5a450c.png";